import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface InventoryItemMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allInventoryItemList: any[];
}

const initialState: InventoryItemMasterState = {
  data: null,
  currentPage: null,
  totalRecords: null,
  totalPages: null,
  allInventoryItemList: [],
};

export const inventoryItemMasterSlice = createSlice({
  name: "inventoryItemMaster",
  initialState,
  reducers: {
    setInventoryItemMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setInventoryItemMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setInventoryItemMasterList: (state, action) => {
      state.allInventoryItemList = action.payload.data;
    },
    reset: () => initialState,
  },
});

export const {
  setInventoryItemMaster,
  setInventoryItemMasterBySearch,
  setInventoryItemMasterList,
  reset,
} = inventoryItemMasterSlice.actions;

export const getInventoryItemMasterDetails = (state: RootState) =>
  state.inventoryItemMaster.data;
export const getInventoryItemMasterTotalRecords = (state: RootState) =>
  state.inventoryItemMaster.totalRecords;
export const getInventoryItemMasterSearch = (state: RootState) =>
  state.inventoryItemMaster.data;
export const getInventoryItemMasterList = (state: RootState) =>
  state.inventoryItemMaster.allInventoryItemList;

export default inventoryItemMasterSlice.reducer;
